let isStandalone = false;

if ('matchMedia' in window) {
    if (matchMedia('(display-mode: standalone)').matches) {
        isStandalone = true;
    } else if ('standalone' in navigator) {
        isStandalone = navigator.standalone;
    }
}

export default isStandalone;
